/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';

type FormSectionProps = {
	children: React.ReactNode;
};

/**
 * __Form section__
 *
 * A section within the appearance controls form, with optional border.
 */
const FormSection: ({ children }: FormSectionProps) => JSX.Element = ({
	children,
}: FormSectionProps) => {
	return (
		<Box>
			<Stack space="space.150">{children}</Stack>
		</Box>
	);
};

export default FormSection;
